import { render } from "./ToothChart.vue?vue&type=template&id=410be794&scoped=true"
import script from "./ToothChart.vue?vue&type=script&lang=js"
export * from "./ToothChart.vue?vue&type=script&lang=js"

import "./ToothChart.vue?vue&type=style&index=0&id=410be794&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410be794"]])

export default __exports__